import type { ReactNode } from "react";

type StartPageContainerProps = {
  children: ReactNode;
};

export default function StartPageContainer({
  children,
}: StartPageContainerProps) {
  return <div className="max-w-5xl mx-auto px-3">{children}</div>;
}
